module.exports = __webpack_public_path__ + "img/country-switcher-cart-icon.fbb8233c.svg";